module.exports = __webpack_public_path__ + "adbddabff386f530afddd05552d24278.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/quarantaene.jpg
// module id = 906
// module chunks = 0